import React, { useState, useEffect, useRef } from "react";
import { Context } from "../classes/context";
import * as RB from 'react-bootstrap';
import "./Props.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRedoAlt, faUndoAlt } from "@fortawesome/free-solid-svg-icons";
import * as cv from "../opencv";
import { useSelector, useDispatch } from "react-redux";
console.log(cv);
export const IdleTool = (props) => {
    const form = (
        <RB.Form>
            <RB.Form.Group>
            </RB.Form.Group>
        </RB.Form>
    );
    return form;
}



